import { z } from "zod";

const guestSchema = z.object({
  userId: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  isExternal: z.boolean().optional(),
  isModerator: z.boolean().optional(),
  isHost: z.boolean().optional(),
});

const addAttendeeSchema = z.object({
  guests: z
    .array(guestSchema)
    .min(1, { message: "At least one guest is required" }),
});

type AddAttendeeFormData = z.infer<typeof addAttendeeSchema>;

export { addAttendeeSchema, type AddAttendeeFormData };
